import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { get_all_barcode } from "../../../../../../API/Camera";
import Panel from "./Panel/index";
import Card from "../../../../../../components/Card";
import cn from "classnames";
import styles from "./View.module.sass";
import Table from "../Table";
import { useReactToPrint } from "react-to-print";


const View = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [barcodes, setBarcodes] = useState([]);
  const printRef = React.useRef();
  const handleCreateBarcode = () => {
    navigate(
      "/settingsDashboard/camera&Barcode/actionBarcodesForCamera/create"
    );
  };

  const fetchAllBarcode = async () => {
    const res = await get_all_barcode();
    setBarcodes(res.data);
  };

  useEffect(() => {
    fetchAllBarcode();
  }, []);

  const handlePrintAll = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Barcodes",
    pageStyle: "@page { size: A4; margin: 20mm; }",
  });
  return (
    <>
      <Card
        className={cn(styles.card)}
        title="Barcode"
        classTitle="title-green"
      >
        <div className={styles.list}>
          <Table
            data={barcodes}
            className={styles.table}
            activeTable={visible}
            setActiveTable={setVisible}
            printRef={printRef}
          />
        </div>
      </Card>
      <div className="fixed bottom-7 left-30 right-5">
        <Panel
          onCreateClick={handleCreateBarcode}
          onPrintAllClick={handlePrintAll}
        />
      </div>
    </>
  );
};

export default View;
